


import React from 'react'

export const RaporlamaPage = () => {
  return (
    <div>RaporlamaPage</div>
  )
}
